export default __webpack_public_path__ + "static/media/ponentes___EnriqueMotolai.b524a621.jpg";